define(["underscore","@bingads-webui-clientcenter/window-interface","bluebird","jquery","@bingads-webui-universal/temporal-utitlities","@bingads-webui-universal/primitive-utilities"], function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__14__, __WEBPACK_EXTERNAL_MODULE__15__, __WEBPACK_EXTERNAL_MODULE__69__, __WEBPACK_EXTERNAL_MODULE__70__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 63);
/******/ })
/************************************************************************/
/******/ ({

/***/ 14:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__14__;

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__15__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(64);


/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StringUtils = exports.NumberUtils = exports.LogUtils = exports.FormUtils = exports.FileUtils = exports.DateUtils = exports.Constants = void 0;

var Constants = _interopRequireWildcard(__webpack_require__(65));

exports.Constants = Constants;

var DateUtils = _interopRequireWildcard(__webpack_require__(68));

exports.DateUtils = DateUtils;

var FileUtils = _interopRequireWildcard(__webpack_require__(71));

exports.FileUtils = FileUtils;

var FormUtils = _interopRequireWildcard(__webpack_require__(72));

exports.FormUtils = FormUtils;

var NumberUtils = _interopRequireWildcard(__webpack_require__(73));

exports.NumberUtils = NumberUtils;

var StringUtils = _interopRequireWildcard(__webpack_require__(74));

exports.StringUtils = StringUtils;

var LogUtils = _interopRequireWildcard(__webpack_require__(75));

exports.LogUtils = LogUtils;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _date = __webpack_require__(66);

Object.keys(_date).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _date[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _date[key];
    }
  });
});

var _grid = __webpack_require__(67);

Object.keys(_grid).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _grid[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _grid[key];
    }
  });
});

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StandardDateFormat = exports.MillisecondsPerDay = exports.FrequencyMonthCountMap = void 0;
var StandardDateFormat = 'M/d/yyyy';
exports.StandardDateFormat = StandardDateFormat;
var MillisecondsPerDay = 86400000;
exports.MillisecondsPerDay = MillisecondsPerDay;
var FrequencyMonthCountMap = Object.freeze({
  Monthly: 1,
  BIMonthly: 2,
  Quarterly: 3,
  Yearly: 12
});
exports.FrequencyMonthCountMap = FrequencyMonthCountMap;

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridStringNoValue = void 0;
var GridStringNoValue = '-';
exports.GridStringNoValue = GridStringNoValue;

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseNormalizedDateRange = exports.normalizeDateRange = exports.isDateWithoutTimeEqual = exports.getTimestampMillis = exports.getPSTDateNow = exports.getNFrequencyEndDate = exports.getDateDiffInDays = exports.addDays = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(3));

__webpack_require__(15);

var _temporalUtitlities = __webpack_require__(69);

var _primitiveUtilities = __webpack_require__(70);

var _windowInterface = _interopRequireDefault(__webpack_require__(4));

var _date = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ATTENTION: You can directly using the i18n.getToday({ timeZone: 'America/Los_Angeles' }) method.
 * This is just a reminder in case you don't know or forget that i18n.getToday.
 * Returns the current date (without time) now of PST timezone.
 * @function
 * @returns {date} the current PST date now. Failed will return null.
 */
var getPSTDateNow = function getPSTDateNow(_ref) {
  var i18n = _ref.i18n;

  if (_underscore.default.isFunction(i18n.getToday)) {
    var todayObj = i18n.getToday({
      timeZone: 'America/Los_Angeles'
    });
    return new Date(todayObj.year, todayObj.month - 1, todayObj.day);
  }
  /* istanbul ignore next */


  return null;
};
/**
 * Returns the numbers of different days from the fromDate minus the endDate
 * Result possitive means fromDate is later then toDate, negative means fromDate is eariler than toDate
 * @function
 * @param {date} fromDate the date of from
 * @param {date} toDate the date of to
 * @returns {number} number of days, if input is invalid will return null.
 */


exports.getPSTDateNow = getPSTDateNow;

var getDateDiffInDays = function getDateDiffInDays(_ref2) {
  var fromDate = _ref2.fromDate,
      toDate = _ref2.toDate;
  return _underscore.default.isDate(fromDate) && _underscore.default.isDate(toDate) ? Math.ceil((fromDate - toDate) / _date.MillisecondsPerDay) : null;
};
/**
 * Returns the date after a certain days from provided fromDate
 * @function
 * @param {date} fromDate the date of from
 * @param {number} offset the offset days, if offsetis larger than 0, it means getting date after, vice versa
 * @returns {date} the result date after setting offset, if input is invalid will return null.
 */


exports.getDateDiffInDays = getDateDiffInDays;

var addDays = function addDays(_ref3) {
  var fromDate = _ref3.fromDate,
      offset = _ref3.offset;
  return _underscore.default.isDate(fromDate) && _underscore.default.isNumber(offset) ? new Date(fromDate.getTime() + offset * _date.MillisecondsPerDay) :
  /* istanbul ignore next */
  null;
};
/**
 * @typedef {object} NormalizedDateRange - Normalized date range
 * @property {string} start - start date string
 * @property {string} end - end date string
 * @property {number} rangeId - date range Id
 */

/**
 * @typedef {object} ParsedDateRange - Parsed date range
 * @property {object} range - date range
 * @property {CivilDate} range.start - start dat
 * @property {CivilDate} range.end - end date
 * @property {number} rangeId - date range Id
 */

/**
 * Normalize date range
 * @function
 * @param {object} dateRangeObject - parsed date range object with i18n and date format pattern
 * @param {object} dateRangeObject.i18n - i18n model
 * @param {object} dateRangeObject.range - date range object
 * @param {CivilDate} dateRangeObject.range.start - start date
 * @param {CivilDate} dateRangeObject.range.end - end date
 * @param {number} dateRangeObject.rangeId - range Id
 * @returns {NormalizedDateRange} - normalized date range
 */


exports.addDays = addDays;

var normalizeDateRange = function normalizeDateRange(_ref4) {
  var i18n = _ref4.i18n,
      _ref4$range = _ref4.range,
      start = _ref4$range.start,
      end = _ref4$range.end,
      rangeId = _ref4.rangeId,
      _ref4$dateFormat = _ref4.dateFormat,
      dateFormat = _ref4$dateFormat === void 0 ? _date.StandardDateFormat : _ref4$dateFormat;
  return {
    start: (0, _temporalUtitlities.formatCivilDate)({
      i18n: i18n,
      date: start,
      dateFormat: dateFormat
    }),
    end: (0, _temporalUtitlities.formatCivilDate)({
      i18n: i18n,
      date: end,
      dateFormat: dateFormat
    }),
    rangeId: rangeId
  };
};
/**
 * Parse normalized date range.
 * @function
 * @param {object} dateRangeObject - date range object with i18n and date format pattern
 * @param {object} dateRangeObject.i18n - i18n model
 * @param {string} dateRangeObject.start - start date
 * @param {string} dateRangeObject.end - end date
 * @param {number} dateRangeObject.rangeId - range Id
 * @param {string} dateRangeObject.dateFormat - date format pattern
 * @returns {ParsedDateRange} - parsed date range object
 */


exports.normalizeDateRange = normalizeDateRange;

var parseNormalizedDateRange = function parseNormalizedDateRange(_ref5) {
  var i18n = _ref5.i18n,
      start = _ref5.start,
      end = _ref5.end,
      rangeId = _ref5.rangeId,
      _ref5$dateFormat = _ref5.dateFormat,
      dateFormat = _ref5$dateFormat === void 0 ? _date.StandardDateFormat : _ref5$dateFormat;
  var startCivilDate = (0, _temporalUtitlities.parseCivilDate)({
    i18n: i18n,
    dateString: start,
    dateFormat: dateFormat
  });
  var endCivilDate = (0, _temporalUtitlities.parseCivilDate)({
    i18n: i18n,
    dateString: end,
    dateFormat: dateFormat
  });
  return startCivilDate && endCivilDate ? {
    range: {
      start: startCivilDate,
      end: endCivilDate
    },
    rangeId: rangeId
  } : null;
};
/**
 * Get end date by start date & frequency & occurences.
 * @function
 * @param {date} startDate - start date
 * @param {string} frequency - frequency
 * @param {number} occurrences - occurrences
 * @returns {date} - end date
 */


exports.parseNormalizedDateRange = parseNormalizedDateRange;

var getNFrequencyEndDate = function getNFrequencyEndDate(startDate, frequency, occurrences) {
  if (!_underscore.default.isDate(startDate) || !_date.FrequencyMonthCountMap[frequency] || !_underscore.default.isNumber(occurrences)) return null;
  var calculateOccurrences = parseInt(occurrences, 10) > 0 ? parseInt(occurrences, 10) : 1;
  var startYear = startDate.getFullYear();
  var startMonth = startDate.getMonth();
  var startDay = startDate.getDate();
  var endRawMonth = calculateOccurrences * _date.FrequencyMonthCountMap[frequency] + startMonth;
  var endYear = startYear + endRawMonth / 12;
  var endMonth = endRawMonth % 12;
  var monthDayCount = new Date(endYear, endMonth + 1, 0
  /* the 0th day means last day in last month */
  ).getDate(); // The logic in MT
  // https://msasg.visualstudio.com/DefaultCollection/Bing_Ads/_git/AnB?path=/private/ClientCenter/MT/Source/ClientCenter/EO/BillingMT/InsertionOrder/RecurringInsertionOrderAddEO.cs&version=GBmaster&line=82&lineEnd=93&lineStartColumn=17&lineEndColumn=43&lineStyle=plain&_a=contents
  // There are some by design but strange logic:
  // Start Date: 08/30/2022 -> End Date: 09/29/2022
  // Start Date: 08/31/2022 -> End Date: 09/29/2022
  // Start Date: 01/31/2022 -> End Date: 02/27/2022
  // Start Date: 01/31/2020 -> End Date: 02/28/2020
  // So the `monthDayCount` should minus 1

  var endDay = Math.min(startDay - 1, monthDayCount - 1);
  var endDate = new Date(endYear, endMonth, endDay);
  return _underscore.default.isNaN(Date.parse(endDate)) ? null : endDate;
};
/**
 * Performs an optimized deep comparison between the two dates, to determine if they should be considered equal.
 * @function
 * @param {date} date1 - date
 * @param {date} date2 - date
 * @returns {bool} - is equal or not
 */


exports.getNFrequencyEndDate = getNFrequencyEndDate;

var isDateWithoutTimeEqual = function isDateWithoutTimeEqual(date1, date2) {
  return _underscore.default.isDate(date1) && _underscore.default.isDate(date2) && (_underscore.default.isEqual((0, _primitiveUtilities.withoutTime)(date1), (0, _primitiveUtilities.withoutTime)(date2)) || _underscore.default.isNaN(date1.getTime()) && _underscore.default.isNaN(date2.getTime()));
};
/**
 * Get current timestamp.
 * @function
 * @returns {number} - timestamp
 */


exports.isDateWithoutTimeEqual = isDateWithoutTimeEqual;

var getTimestampMillis = function getTimestampMillis() {
  /* istanbul ignore next */
  if (typeof _windowInterface.default.performance !== 'undefined' && _windowInterface.default.performance.now) {
    return _windowInterface.default.performance.now();
  }
  /* istanbul ignore next */


  return Date.now();
};

exports.getTimestampMillis = getTimestampMillis;

/***/ }),

/***/ 69:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__69__;

/***/ }),

/***/ 70:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__70__;

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__webpack_provided_Number_dot_isNaN) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.readFileAsByteAray = exports.containsFile = exports.buildFormData = void 0;

var _bluebird = _interopRequireDefault(__webpack_require__(14));

var _underscore = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Use FileReader to read file as byte array. For FileReader, @see {@link https://developer.mozilla.org/en-US/docs/Web/API/FileReader}
 * Browser compatibility: IE 10/Chrome 7/Firefox 3.6/Edge 12
 * @function
 * @param {object} obj Parameter object
 * @property {File} obj.file The file needs to be converted
 * @returns {Promise<Array<Number>>} Promise, will resolve a byte array
 */
var readFileAsByteAray = function readFileAsByteAray(_ref) {
  var file = _ref.file;
  return new _bluebird.default(function (resolve) {
    var reader = new FileReader();

    reader.onload = function (_ref2) {
      var result = _ref2.target.result;
      resolve(_underscore.default.toArray(new Uint8Array(result)));
    };

    reader.readAsArrayBuffer(file);
  });
};
/**
 * Append extra data to FormData object before sent to server, modified the solution https://stackoverflow.com/questions/22783108/convert-js-object-to-form-data/42483509#42483509,
 * and adapted it to ASP.NET MVC: Object property will be chained by '.', Array index will be wrapped with '[]'.
 * This function is mainly created for sending data and files together.
 * Example:
 *  Passed-in arguments
 *    formData: { FormKey1: '1', FormKey2: 2 }
 *    data: {
 *            JsonKey1: {
 *              JsonKey2: 3
 *            },
 *            JsonKey3: [
 *              { JsonKey4: '4' }
 *            ],
 *            JsonKey5: fileObj,
 *            JsonKey6: null,
 *            JsonKey7: () => {}
 *          }
 *    parentKey: 'ParentKey'
 *  Returned value:
 *    formData: {
 *                 FormKey1: '1',
 *                 FormKey2: '2',
 *                 ParentKey.JsonKey1.JsonKey2: '3',
 *                 ParentKey.JsonKey3[0].JsonKey4: '4',
 *                 ParentKey.JsonKey5: fileObj,
 *                 ParentKey.JsonKey6: ''
 *              }
 * @param {FormData} formData - the original FormData object reference, it can be empty FormData or FormData with some values
 * @param {*} data - the data to append, can be any type
 * @param {string} parentKey - the parentKey to data, will be the prefix of data's property names
 * @returns {FormData} the appended FormData object
 */


exports.readFileAsByteAray = readFileAsByteAray;

var buildFormData = function buildFormData(formData, data, parentKey) {
  if (data && _typeof(data) === 'object' && !(data instanceof Date) && !(data instanceof Blob)) {
    var subKeyFormatter = Array.isArray(data) ? function (key) {
      return "[".concat(key, "]");
    } : function (key) {
      return ".".concat(key);
    };
    Object.keys(data).forEach(function (key) {
      buildFormData(formData, data[key], parentKey ? "".concat(parentKey).concat(subKeyFormatter(key)) : key);
    });
  } else if (parentKey && typeof data !== 'function') {
    var value = data === null || data === undefined || __webpack_provided_Number_dot_isNaN(data) ? '' : data;
    formData.append(parentKey, value);
  }

  return formData;
};
/**
 * Recursively detect if the data contains file.
 * Return true if the data is an instance of Blob, or the data is an object containing Blob,
 * otherwise return false.
 * @param {*} data - the data to check, can be any type
 * @returns {bool} the bool result
 */


exports.buildFormData = buildFormData;

var containsFile = function containsFile(data) {
  if (data instanceof Blob) {
    return true;
  }

  if (data && _typeof(data) === 'object') {
    return Object.values(data).some(containsFile);
  }

  return false;
};

exports.containsFile = containsFile;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(3)["isNaN"]))

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postRedirect = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addInputToForm(_ref) {
  var form = _ref.form,
      name = _ref.name,
      value = _ref.value;
  var hiddenField = document.createElement('input');
  hiddenField.setAttribute('type', 'hidden');
  hiddenField.setAttribute('name', name);
  hiddenField.setAttribute('value', value);
  form.appendChild(hiddenField);
}
/**
  * POSTS a form with a full page redirect
  * @param {url} url to POST to
  * @param {fields} fields which can be used for POSTing parameters
  * @returns {void} Nothing
*/


var postRedirect = function postRedirect(_ref2) {
  var url = _ref2.url,
      fields = _ref2.fields;
  var form = document.createElement('form');
  form.setAttribute('method', 'post');
  form.setAttribute('action', url);

  _underscore.default.each(fields, function (field) {
    addInputToForm({
      form: form,
      name: field.name,
      value: field.value
    });
  });

  document.body.appendChild(form);
  form.submit();
};

exports.postRedirect = postRedirect;

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeFlag = exports.isValidWholeNumber = exports.hasFlag = exports.getPercentage = exports.dividePossibleZero = exports.addFlag = void 0;

var _jquery = _interopRequireDefault(__webpack_require__(15));

var _underscore = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultOptions = {
  precision: 2,
  needPercentageSymbol: true,
  needSpace: false
};
/**
 * Return true if the string in parameter is a valid integer greater or equal to Zero
 * @param {string|Number} numberValue The number value to test, can be a string or a number type.
 * @returns {boolean} True if the string in parameter is a string greater or equal to 0
 */

var isValidWholeNumber = function isValidWholeNumber(numberValue) {
  var number = Math.floor(Number(numberValue));
  return String(number) === String(numberValue) && number >= 0;
};
/**
 * Return input source in percentage format
 * @param {number} source The input source. Need to be number, otherwise will return undefined.
 * @param {object} [options] Options.
 * @param {int} [options.precision] How many digits of decimals want to keep. Default is 2.
 * @param {bool} [options.needPercentageSymbol] Whether need a percentage symbol '%'. Default is true.
 * @param {bool} [options.needSpace] Wehther need a spance between the value and percentage symbol. Defualt is false.
 * @returns {string} Result.
 */


exports.isValidWholeNumber = isValidWholeNumber;

var getPercentage = function getPercentage(source, options) {
  var _$extend = _underscore.default.extend({}, defaultOptions, options),
      precision = _$extend.precision,
      needPercentageSymbol = _$extend.needPercentageSymbol,
      needSpace = _$extend.needSpace;

  if (!_jquery.default.isNumeric(source)) {
    return null;
  }

  return "".concat(Number(source * 100).toFixed(precision)).concat(needSpace ? ' ' : '').concat(needPercentageSymbol ? '%' : '');
};
/**
 * Return the devided result by handling the divisor or dividend is 0 case.
 * @param {number} divisor The divisor.
 * @param {number} dividend The dividend.
 * @returns {number} Divided result.
 */


exports.getPercentage = getPercentage;

var dividePossibleZero = function dividePossibleZero(divisor, dividend) {
  return dividend === 0 ? 0 : divisor / dividend;
};
/**
 * Determines whether one or more bit fields are set in the current instance.
 * Need to disable eslint for bitwise operation, that is considered as too rarely used to be expected in js code: https://eslint.org/docs/rules/no-bitwise
 * @param {number} number The current instance value number. Need to be a numeric value instance of number or string
 * @param {number} flag A value representing the bit field that should be present in the number
 * @returns {bool} true if the bit field or bit fields that are set in flag are also set in the current instance; otherwise, false
 */


exports.dividePossibleZero = dividePossibleZero;

var hasFlag = function hasFlag(number, flag) {
  return isValidWholeNumber(number) && (Number(number) & flag) === flag;
}; // eslint-disable-line no-bitwise

/**
 * Returns a new number with one bit fields added.
 * @param {number} number The current instance value number. Need to be a numeric value instance of number or string
 * @param {number} flag A value representing the bit field that should be added from the number
 * @returns {number} a new number with one bit fields added.
 */


exports.hasFlag = hasFlag;

var addFlag = function addFlag(number, flag) {
  var num = isValidWholeNumber(number) ? Number(number) : 0;
  return num | flag; // eslint-disable-line no-bitwise
};
/**
 * Returns a new number with one bit fields removed if exists, or the same number if flag is not present. Returns null if last flag is removed.
 * @param {number} number The current instance value number. Need to be a numeric value instance of number or string
 * @param {number} flag A value representing the bit field that should be removed from the number
 * @returns {number} a new number with one bit fields removed if exists, or the same number if flag is not present. Returns null if last flag is removed.
 */


exports.addFlag = addFlag;

var removeFlag = function removeFlag(number, flag) {
  // If the number doesn't have the flag we should not try to XOR otherwise result will be 0 instead of the value without flag
  if (hasFlag(number, flag)) {
    return Number(number) ^ flag || null; // eslint-disable-line no-bitwise
  }

  return number;
};

exports.removeFlag = removeFlag;

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isStringNotBlank = exports.format = exports.encode = exports.decode = void 0;
Object.defineProperty(exports, "isValidWholeNumber", {
  enumerable: true,
  get: function get() {
    return _numberUtils.isValidWholeNumber;
  }
});
exports.regexTest = exports.parseStringToBool = exports.parseBase64ToString = void 0;

var _jquery = _interopRequireDefault(__webpack_require__(15));

var _underscore = _interopRequireDefault(__webpack_require__(3));

var _numberUtils = __webpack_require__(73);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This function is the same of the one in number-utils
 * We also export it in string-util because it can be applied with both string or number passed in parameter
 */

/**
 * Return true if the string in parameter is a string not empty after trim
 * @param {string} str The string to validate.
 * @returns {boolean} True if the string in parameter is a string not empty after trim
 */
var isStringNotBlank = function isStringNotBlank(str) {
  return _underscore.default.isString(str) && !_underscore.default.isEmpty(str.trim());
};
/**
 * Replaces Values of the form {#} with the corresponding argument passed in after format.
 * If # arguments weren't passed in, then {#} is left in the formatted string
 * @param {string} str The string to format.
 * @returns {string} Formats the string with the given arguments
 */


exports.isStringNotBlank = isStringNotBlank;

var format = function format(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return str.replace(/{(\d+)}/g, function (match, number) {
    return typeof args[number] === 'undefined' ? match : args[number];
  });
};
/**
 * Encodes an text into an HTML string
 * @param {string} str The string to encode.
 * @returns {string} An HTML-encoded version of str
 */


exports.format = format;

var encode = function encode(str) {
  return (0, _jquery.default)('<p>').text(str).html();
};
/**
 * Decodes an HTML string into text
 * @param {string} str The string to decode.
 * @returns {string} A plaintext version of the HTML-encoded str
 */


exports.encode = encode;

var decode = function decode(str) {
  return (0, _jquery.default)('<p>').html(str).text();
};
/**
 * Parse a string to bool
 * @param {string|bool} str The string to parse.
 * @returns {bool} The bool value of string
 */


exports.decode = decode;

var parseStringToBool = function parseStringToBool(str) {
  if (_underscore.default.isString(str)) {
    return str.toLowerCase() === 'true';
  }

  if (_underscore.default.isBoolean(str)) {
    return str;
  }

  return false;
};
/**
 * Parse a base64 array to string
 * @param {array} arr The array of base64 bytes.
 * @returns {string} The string translate from base64
 */


exports.parseStringToBool = parseStringToBool;

var parseBase64ToString = function parseBase64ToString(arr) {
  if (arr && arr.length) {
    var bytes = new Uint8Array(arr);
    return btoa(_underscore.default.map(bytes, function (byte) {
      return String.fromCharCode(byte);
    }).join(''));
  }

  return null;
};
/**
 * Test a string using a given regexString
 * @param {string} regexStr The given regexString
 * @param {string} str The string to test
 * @returns {bool} Indicate whether the string fulfils the regexString
 */


exports.parseBase64ToString = parseBase64ToString;

var regexTest = function regexTest(regexStr, str) {
  var reg = new RegExp(regexStr);
  return reg.test(str);
};

exports.regexTest = regexTest;

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logPageLoadAndNavigationDuration = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(3));

__webpack_require__(15);

var _windowInterface = _interopRequireDefault(__webpack_require__(4));

var _dateUtils = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Mark the page load time when page is loaded.
 * Log the page duration when page is navigated
 * @function
 * @param {logging} logging to log
 * @param {pageReadyMark} pageReadyMark which can be used for performance mark
  * @returns {void} Nothing
 */
var logPageLoadAndNavigationDuration = function logPageLoadAndNavigationDuration(_ref) {
  var logging = _ref.logging,
      pageReadyMark = _ref.pageReadyMark;

  if (_windowInterface.default.pageLoadDurationRecorded && _windowInterface.default.pageNavigationStartTime && _windowInterface.default.pageNavigationRecorded && logging && logging.pageRoutePageLoadDuration) {
    logging.pageRoutePageLoadDuration(_windowInterface.default.location.pathname, (0, _dateUtils.getTimestampMillis)() - _windowInterface.default.pageNavigationStartTime, _windowInterface.default.pageNavigationRecorded[pageReadyMark]);
    _windowInterface.default.pageNavigationRecorded[pageReadyMark] = true;
  }

  if (!_windowInterface.default.pageLoadDurationRecorded && _windowInterface.default.location.pathname === _windowInterface.default.pageLandingPath) {
    _windowInterface.default.performance.mark("".concat(pageReadyMark, "LandingPageReady"));

    _windowInterface.default.pageLoadDurationRecorded = true;
    _windowInterface.default.pageNavigationRecorded = _underscore.default.extend(_windowInterface.default.pageNavigationRecorded, _defineProperty({}, pageReadyMark, true));
  }
};

exports.logPageLoadAndNavigationDuration = logPageLoadAndNavigationDuration;

/***/ })

/******/ })});;
